import { FormattedMessage } from 'react-intl'
import TrustPilot from '../../../../../checkout/TrustPilot'
import styles from './EnquirySidePanel.module.scss'

export default function EnquirySidePanel() {
  return (
    <div className={styles.panel}>
      <div className={styles.copy}>
        <p>
          <FormattedMessage
            id='enquiry_side_panel_intro'
            defaultMessage='This looks like an epic trip that would make other divers envious!'
          />
        </p>
        <p>
          <FormattedMessage
            id='enquiry_side_panel_followup'
            defaultMessage="After you have submitted your enquiry, we'll check availability and reserve you a spot with zero obligations. This is usually completed within 24 hours."
          />
        </p>
        <p>
          <FormattedMessage
            id='enquiry_side_panel_payment'
            defaultMessage="Then, we'll work with you to confirm all your travel details and answer all outstanding questions before any payment is taken."
          />
        </p>
        <p>
          <FormattedMessage
            id='enquiry_side_panel_chat'
            defaultMessage='If you have any questions, start a live chat with one of our award-winning Scuba Travel Expert Team!'
          />
        </p>
      </div>
      <div className={styles.awardsWrap}>
        <div className={styles.awardRow}>
          <img
            src={`${window.staticPath}travel_dist/images/reward-readers-choice.png`}
            alt=''
            className={styles.awardLogo}
          />
          <div>
            <p className={styles.awardTitle}>
              <FormattedMessage
                id='enquiry_award_title'
                defaultMessage='5x BEST DIVE TRAVEL AGENCY'
              />
            </p>
            <p className={styles.awardSubtitle}>
              <FormattedMessage
                id='enquiry_award_subtitle'
                defaultMessage='Scuba Diving Magazine Readers Choice Award, 2022 - 2026'
              />
            </p>
          </div>
        </div>
        <TrustPilot />
      </div>
    </div>
  )
}
